
export const getServiceType = (service = 'ELECTRICITY') => {
    switch (service) {
        case 'ELECTRICITY':
            return 'Electricity';
        case 'AIRTIME':
            return 'Airtime';
        case 'CABLE':
            return 'Cable';
        case 'DATA':
            return 'Data';
        case 'VTU':
            return 'Airtime';
        default:
            return '';
    }
}

export const getimagepath = (vertical = '') => {
    const verticalName = vertical.toUpperCase();
    switch (verticalName) {
        case 'ABUJA':
        case 'NIGER':
            return require('../assets/svgs/aedc-icon.svg');
        case 'ABA':
            return require('../assets/svgs/aba.svg');
        case 'BENIN':
            return require('../assets/discos/BENIN.svg');
        case 'EKEDC':
        case 'EKO':
            return require('../assets/discos/EKEDC.svg');
        case 'IBADAN':
            return require('../assets/discos/IBEDC.png');
        case 'IKEJA':
            return require('../assets/discos/IKEDC.png');
        case 'JOS':
            return require('../assets/discos/JOS.png');
        case 'KADUNA':
            return require('../assets/discos/KAEDCO.png');
        case 'KANO':
            return require('../assets/discos/KEDCO.png');
        case 'ENUGU':
            return require('../assets/discos/EEDC.svg');
        case 'PHED':
            return require('../assets/discos/PHED.png');
        case 'MTN':
            return require('../assets/discos/MTN.svg');
        case 'GLO':
            return require('../assets/discos/GLO.svg');
        case 'AIRTEL':
            return require('../assets/discos/AIRTEL.svg');
        case '9MOBILE':
            return require('../assets/discos/9MOBILE.svg');
        case 'DSTV':
            return require('../assets/discos/DSTV.svg');
        case 'GOTV':
            return require('../assets/discos/GOTV.svg');
        case 'STARTIMES':
            return require('../assets/discos/STARTIMES.svg');
        case 'ELECTRICITY':
            return require('../assets/svgs/bulb-icon.svg');
        case 'AIRTIME':
            return require('../assets/discos/AIRTIME.svg');
        case 'CABLE':
            return require('../assets/discos/CABLE.svg');
        case 'DATA':
            return require('../assets/discos/DATA.svg');
        default:
            return '';
    }
}

export default {
    getimagepath,
    getServiceType
}



// WEBPACK FOOTER //
// ./src/utils/verticalAssets.js